<div class="mobile-header">
  <div class="logo" *ngIf="!showSearch">
    <img [src]="getLogo()" alt="Logo">
  </div>


  <ng-container *ngIf="isLoginMenu">
    <div class="frame-buttons">
      <button [matMenuTriggerFor]="menu" mat-icon-button>
        <img src="assets/icons/menu.svg">
      </button>
      <mat-menu #menu="matMenu" class="custom-menu">
        <div class="menu-container">
          <app-button (click)="openRegistrationPage()" [label]="'auth.register' | translate"
                      [size]="ButtonSize.LARGE"
                      [state]="ButtonState.REGULAR" [type]="ButtonType.PRIMARY"></app-button>
          <app-button (click)="openLoginPopup()" [label]="'auth.login' | translate" [size]="ButtonSize.LARGE"
                      [state]="ButtonState.REGULAR" [type]="ButtonType.SECONDARY"></app-button>
        </div>
      </mat-menu>
    </div>
  </ng-container>

  <ng-container *ngIf="isNotifications">
    <mat-icon (click)="handleNotificationClick()" *ngIf="!showSearch">notifications_active</mat-icon>

    <app-notification-panel
      *ngIf="showNotificationsPanel"
      [notifications]="notifications"
      (close)="toggleNotificationsPanel()"
      class="notification-menu">
    </app-notification-panel>
  </ng-container>
</div>

<mat-divider></mat-divider>
